var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-offline"},[_c('div',{staticClass:"container-lottie"},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"animCreated":_vm.handleAnimation}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }